<template>
  <div class="container-fluid full-height">
    <div class="row row-height">
      <hello />

      <div class="col-lg-6" id="start">
        <div id="wizard_container">
          <div class="mb-2">
            <LanguageSelect />
          </div>

          <div id="top-wizard">
            <div id="progressbar"></div>
          </div>
          <!-- /top-wizard -->
          <form id="wrapped" method="POST" @submit.prevent="forgot">
            <input id="website" name="website" type="text" value />
            <!-- Leave for security protection, read docs for details -->
            <div id="middle-wizard">
              <div class="submit step">
                <!-- Sifremi unuttum -->
                <h3 class="main_question" v-if="!success"></h3>
                <p v-if="!success">
                  {{ $t('Şifre unuttum aciklama') }}
                </p>
                <InputField
                  v-if="!success"
                  v-model.trim="email"
                  name="email"
                  :placeholder="$t('E-posta')"
                  v-validate="'required|email'"
                  :error="errors.first('email')"
                  errorBox="email"
                  :validateFields="fields['email']"
                />
                <!-- Sifremi unuttum mail gönderildi -->
                <h3 class="main_question" v-if="success">{{ $t('Posta gönderme Text') }}</h3>
                <p v-if="success">
                  {{ $t('Şifre gönderim onay text') }}
                </p>
              </div>

              <button v-if="!success" type="submit" :disabled="isWaiting" name="process" class="submit">
                {{ $t('Şifremi Gönder') }}
              </button>
            </div>
            <!-- /middle-wizard -->
            <div id="bottom-wizard"></div>
            <!-- /bottom-wizard -->
            <div class="form-group">
              <div class="row">
                <div class="col-12">
                  <strong>
                    <router-link :to="pathFindWithLanguage('/login')">{{ $t('Giriş Yap') }}</router-link>
                  </strong>
                </div>
              </div>
            </div>
          </form>
        </div>
        <!-- /Wizard container -->
      </div>
      <!-- /content-right-->
    </div>
    <!-- /row-->
  </div>
</template>
<script>
import LanguageSelect from './../components/LanguageSelect.vue';
import InputField from './../components/InputField.vue';
export default {
  components: {
    LanguageSelect,
    InputField,
  },
  data() {
    return {
      email: null,
    };
  },
  methods: {
    forgot() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          const form = $('form#wrapped');
          form.validate();
          if (form.valid()) {
            this.$store.commit('setWaiting', true);
            $axios
              .post('reset-password', {
                email: this.email,
              })
              .then((s) => {
                this.$toasted.show(this.$t('AlertMessages.Lütfen e-Postanıza gönderdiğimiz talimatları takip edin'));
                this.success = true;
              });
          }
        }
      });
    },
  },
};
</script>
